import 'overlayscrollbars/styles/overlayscrollbars.css';

import { OverlayScrollbars } from 'overlayscrollbars';

const bodies = document.querySelectorAll<HTMLElement>('.se-multi-checkbox__body-inner');

bodies.forEach(bodyItem => {
  OverlayScrollbars(bodyItem, {
    overflow: {
      x: "hidden"
    }
  });
});
